import withAPIAction from 'helpers/withAPIAction'
import { PointRedeemReq, UpdateRedeemStatusReq, PointListReq } from './types'
import { getRedeemListAction, updateRedeemStatusAction, getPointListAction } from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const redeemListAPI = (data: PointRedeemReq, token: string, xmid: string) => {
  return withAPIAction<PointRedeemReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.redeemList,
    data,
    token,
    xmid,
  })(getRedeemListAction)
}

export const updateRedeemStatusAPI = (data: UpdateRedeemStatusReq, token: string, xmid: string) => {
  return withAPIAction<UpdateRedeemStatusReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateRedeemStatus,
    data,
    token,
    xmid,
  })(updateRedeemStatusAction)
}

export const pointListAPI = (data: PointListReq, token: string, xmid: string) => {
  return withAPIAction<PointListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.pointList,
    data,
    token,
    xmid,
  })(getPointListAction)
}
